import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'decodeEntities',
  standalone: false,
})
export class DecodeEntitiesPipe implements PipeTransform {
  /**
   * Transform and return an encoded string from a text area and return inner html
   * string
   * @param encodedString - encoded string that is textarea
   * @returns - inner html string from encoded string from text area.
   */
  public transform(encodedString: string): string {
    const textArea = document.createElement('textarea');
    textArea.innerHTML = encodedString;
    return textArea.value;
  }
}
